import { FieldViewModel } from "../omnia"
import { LayerZone } from "../types"
import { IDashboard, IDashboardContext } from "./types"

export function createDashboardContext(dashboard: IDashboard, current: IDashboardContext): IDashboardContext {

    const selection = getSelection(dashboard, current)

    return {

        ...selection,

        get fields() {
            return dashboard.fields
        },

        get map() {
            return dashboard.map
        },

        get layers() {
            return dashboard.layers
        },

        setSelectedField(item: FieldViewModel, zone: LayerZone, updateMap: boolean) {
            return dashboard.setSelectedField(item, zone, updateMap);
        },

        showDialog(component: string, args: any, optionsOverride?: any) {
            return dashboard.showDialog(component, args, optionsOverride);
        },

        refresh(): ng.IPromise<any> {
            return dashboard.refresh()
        }

    }

}

function getSelection(dashboard: IDashboard, current: IDashboardContext) {

    const fieldId = current?.selectedField?.fieldId
    const croppingId = current?.selectedCropping?.croppingId

    const selectedField = fieldId
        ? dashboard.fields.find(f => f.fieldId == fieldId)
        : undefined

    const selectedCropping = selectedField && croppingId
        ? selectedField.croppings.find(c => c.croppingId == croppingId)
        : undefined

    const selectedZone = (selectedField || selectedCropping) && current.selectedZone
        ? dashboard.map.findZoneInCurrentView(current.selectedZone)
        : undefined


    return {
        selectedField,
        selectedCropping,
        selectedZone,
        selectedHsaId: current?.selectedHsaId,
    }

}
